export default __webpack_public_path__ + "assets/0c1ab78e91ded34c96677aff55e91274.svg";